import { NgModule,Injector,DoBootstrap } from '@angular/core';
import { CommonModule } from '@angular/common';
import { createCustomElement } from '@angular/elements'
import { MenuCategoriasComponent } from './menu-categorias/menu-categorias.component'
import { MaterialModule } from '../../core/material/material.module';


@NgModule({
  imports: [CommonModule,MaterialModule],
  exports:[MenuCategoriasComponent],
  declarations: [MenuCategoriasComponent],
  providers: [],
})

export class WebComponentModule implements DoBootstrap {

  constructor(private injector: Injector){}

  ngDoBootstrap(): void {
    
    const el = createCustomElement(MenuCategoriasComponent,{
      injector : this.injector,
    });

    customElements.define('menu-categorias',el);
  }

 }
